import { ManageCardsService } from './../../payment/manage-cards/manage-cards.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedService } from '../../shared/shared.service';
import { CustomerEnrollService } from '../customer-enroll.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AbstractControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PlanService } from '../../plan/plan.service';
import { MakePaymentService } from '../../payment/make-payment/make-payment.service';
import { LoggerService } from './../../logger/logger.service';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {conformToMask} from 'angular2-text-mask';
import * as _moment from 'moment';
import {PaymentusService} from '../../payment/paymentus/paymentus.service';
const moment = _moment;

// global const
const FULLNAME_REGEX = /^([a-zA-Z]+\s([a-zA-Z]+))$/;
const LETTERS_REGEX = /^[A-Za-z]+[A-Za-z ]*$/;
const MOBILE_REGEX = /^\(\d{3}\)\s\d{3}\-\d{4}$|^\d{10}$/;
const PIN_REGEX = /^\d{4}$/;
const PASSWORD_REGEX = /((?=.*\d)(?=.*[A-Za-z])(?=.*[0-9]).{6,18})/;
const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const DATE_REGEX = /^([0]?[1-9]|[1][0-2])[./-]([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0-9]{4})$/;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//const CARD_REGEX = /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
const CARD_REGEX = /^4[0-9]{3}\-[0-9]{4}\-[0-9]{4}\-[0-9]{1}(?:[0-9]{3})?$|^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)\-[0-9]{4}\-[0-9]{4}\-[0-9]{4}$|^3[47][0-9]{2}\-[0-9]{6}\-[0-9]{5}$|^6(?:011|5[0-9]{2})\-[0-9]{4}\-[0-9]{4}\-[0-9]{4}$/;
const CVV_REGEX = /^[0-9]{3,4}$/;
const EXPIRATIONDATE_REGEX = /^(0[1-9]|1[0-2])\/[0-9]{2}$/;
const AMOUNT_REGEX = /^\d+(\.\d+)?$/;
const dateRegex = new RegExp(DATE_REGEX);

@Component({
	selector: 'app-customer-enroll-wizard-v2',
	templateUrl: './customer-enroll-wizard-v2.component.html',
	styleUrls: ['./customer-enroll-wizard-v2.component.css'],
	providers: [
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
		{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
	],
})
export class CustomerEnrollWizardV2Component implements OnInit {
	public useNewEnrollment = true;
	public mobile_phone_number = "";
	private phone_number = "";
	public email = "";
	public email_verified: boolean = undefined;
	public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	public cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	public expMask = [/\d/, /\d/, '\/', /\d/, /\d/];
	public dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

	// enrollment form wizard validation
	fullNameFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(FULLNAME_REGEX)]);
	firstNameFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(LETTERS_REGEX)]);
	lastNameFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(LETTERS_REGEX)]);
	accPINFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(PIN_REGEX)]);
	mobilePhoneFormControl = new FormControl('', [
		Validators.pattern(MOBILE_REGEX)
	]);
	emailFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(EMAIL_REGEX)
	]);
	passwordFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(PASSWORD_REGEX)
	]);
	billingAddress1FormControl = new FormControl('', [
		Validators.required]);
	cityFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(LETTERS_REGEX)]);
	stateFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(LETTERS_REGEX)]);
	zipCodeFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(ZIPCODE_REGEX)]);
	cardFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(CARD_REGEX)]);

	expirationDateFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(EXPIRATIONDATE_REGEX)]);

	ccvFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(CVV_REGEX)]);
	amountFormControl = new FormControl('', [
		Validators.required,
		Validators.pattern(AMOUNT_REGEX)]);
	dobFormControl = new FormControl('', [
		Validators.required
	]);
	serviceStartFormControl = new FormControl('', [
		Validators.required
	]);

	// wizard public variables
	public doing_personal: string;
	public doing_account: string;
	public doing_service: string;
	public doing_payment: string;
	public complete_personal: string;
	public complete_account: string;
	public complete_service: string;
	public complete_payment: string;
	public is_doing_personal: boolean;
	public is_doing_account: boolean;
	public is_doing_service: boolean;
	public is_doing_cash_only: boolean;
	public is_doing_pre_payment: boolean;
	public is_doing_payment: boolean;
	public is_completed_personal: boolean;
	public is_completed_account: boolean;
	public is_completed_service: boolean;
	public is_completed_pre_payment: boolean;
	public is_completed_payment: boolean;
	public customer_enroll_object: Object;
	public component_load: boolean;
	public is_start_date_today = false;
	public is_filtered_date = false;
	public is_past_start_date = false;
	public amount = '60';
	public autopay_amount ='60';
	public msg_class = '';

	// personal wizard variables
	// public full_name: string;
	public first_name;
	public last_name;
	public date_of_birth;
	public date_dob: Date;
	public acc_pin: string;
	public enroll_personal_valid: boolean;
	public maxDate = new Date();
	public is_mobile_no_exist: boolean;
	public is_email_exist: boolean;
	public date_of_birth_1;
	public month: any;
	public date: any;
	public year: any;
	is_dob_valid: boolean = true;
	is_service_start_valid: boolean = true;
	public birth: any;
	date_error_message: string;
	public invalid_password: boolean;

	public is_valid_amount: boolean = true;
	public is_valid_max: boolean = true;

	// account wizard variables
	public create_password: string;
	public confirm_password: string;
	public prefered_language: string;
	public enroll_account_valid: boolean;
	public form;

	states = [
		{ value: 'AL', viewValue: 'AL' },
		{ value: 'AK', viewValue: 'AK' },
		{ value: 'AZ', viewValue: 'AZ' },
		{ value: 'AR', viewValue: 'AR' },
		{ value: 'CA', viewValue: 'CA' },
		{ value: 'CO', viewValue: 'CO' },
		{ value: 'CT', viewValue: 'CT' },
		{ value: 'DE', viewValue: 'DE' },
		{ value: 'FL', viewValue: 'FL' },
		{ value: 'GA', viewValue: 'GA' },
		{ value: 'HI', viewValue: 'HI' },
		{ value: 'ID', viewValue: 'ID' },
		{ value: 'IL', viewValue: 'IL' },
		{ value: 'IN', viewValue: 'IN' },
		{ value: 'IA', viewValue: 'IA' },
		{ value: 'KS', viewValue: 'KS' },
		{ value: 'KY', viewValue: 'KY' },
		{ value: 'LA', viewValue: 'LA' },
		{ value: 'ME', viewValue: 'ME' },
		{ value: 'MD', viewValue: 'MD' },
		{ value: 'MA', viewValue: 'MA' },
		{ value: 'MI', viewValue: 'MI' },
		{ value: 'MN', viewValue: 'MN' },
		{ value: 'MS', viewValue: 'MS' },
		{ value: 'MO', viewValue: 'MO' },
		{ value: 'MT', viewValue: 'MT' },
		{ value: 'NE', viewValue: 'NE' },
		{ value: 'NV', viewValue: 'NV' },
		{ value: 'NH', viewValue: 'NH' },
		{ value: 'NJ', viewValue: 'NJ' },
		{ value: 'NM', viewValue: 'NM' },
		{ value: 'NY', viewValue: 'NY' },
		{ value: 'NC', viewValue: 'NC' },
		{ value: 'ND', viewValue: 'ND' },
		{ value: 'OH', viewValue: 'OH' },
		{ value: 'OK', viewValue: 'OK' },
		{ value: 'OR', viewValue: 'OR' },
		{ value: 'PA', viewValue: 'PA' },
		{ value: 'RI', viewValue: 'RI' },
		{ value: 'SC', viewValue: 'SC' },
		{ value: 'SD', viewValue: 'SD' },
		{ value: 'TN', viewValue: 'TN' },
		{ value: 'TX', viewValue: 'TX' },
		{ value: 'UT', viewValue: 'UT' },
		{ value: 'VT', viewValue: 'VT' },
		{ value: 'VA', viewValue: 'VA' },
		{ value: 'WA', viewValue: 'WA' },
		{ value: 'WV', viewValue: 'WV' },
		{ value: 'WI', viewValue: 'WI' },
		{ value: 'WY', viewValue: 'WY' },
		{ value: 'DC', viewValue: 'DC' },
		{ value: 'MH', viewValue: 'MH' },
		{ value: 'AE', viewValue: 'AE' },
		{ value: 'AA', viewValue: 'AA' },
		{ value: 'AP', viewValue: 'AP' },
	];

	languages = [
		{ value: 'English', viewValue: 'English' },
		{ value: 'Spanish', viewValue: 'Espa\u00F1ol' }
	];

	// service wizard variables
	public is_billing_add_as_service_add: boolean;
	public service_type: string;
	public live_here: boolean;
	public notify_provider: boolean;
	public service_start_date: Date;
	public moment_start_date: Date;
	public billing_address;
	public billing_address_2;
	public city;
	public state;
	public zip_code;
	public billing_zip_code;
	public enroll_service_valid;
	billing_address_obj: Object;
	esi_id: string;
	public minDobDate = new Date();
	public maxDobDate = new Date();
	public minDate = new Date(new Date().setHours(0, 0, 0, 0));
	public maxDateService = new Date();
	is_confirm_password_match: boolean;
	public laguage_wizard = 'lg-english';
	public date_service_start: string;
	public service_start_upto_days: any;
	public timeover: any;

	public terms_condition: boolean;
	public is_enroll_processing: boolean;
	public is_enroll_process: boolean;
	public has_contact_info: boolean;
	public btn_value: string;
	public critical_care: boolean;
	public disable_div: string;
	public ip_Address: string;
	isSavePaymentProfile = false;

	months = [
		{ value: 'Month', viewValue: 'Month' },
		{ value: '1', viewValue: 'Jan' },
		{ value: '2', viewValue: 'Feb' },
		{ value: '3', viewValue: 'Mar' },
		{ value: '4', viewValue: 'Apr' },
		{ value: '5', viewValue: 'May' },
		{ value: '6', viewValue: 'Jun' },
		{ value: '7', viewValue: 'Jul' },
		{ value: '8', viewValue: 'Aug' },
		{ value: '9', viewValue: 'Sept' },
		{ value: '10', viewValue: 'Oct' },
		{ value: '11', viewValue: 'Nov' },
		{ value: '12', viewValue: 'Dec' },
	];
	dates = [{ value: 'Day', viewValue: 'Day' }];
	years = [{ value: 'Year', viewValue: 'Year' }];

	types = [
		{ value: true, viewValue: 'Yes' },
		{ value: false, viewValue: 'No' }
	];

	notify_current_provider = [
		{ value: true, viewValue: 'Yes, I did' },
		{ value: false, viewValue: 'No, please do that for me' }
	];

	autopay_bold_message = "Enroll with auto recharge?";
	autopay_no_message = "By enrolling in autopay, I authorize Pogo to charge my card $60 now and an additional $60 whenever my balance is $40 or less to recharge my card this same amount. I can change this amount at any time.";
	autopay_message_minimum = "A $60 initial charge-up is required to get started with Pogo.";
	autopay_message_authorize = "I authorize Pogo to charge my card the above amount and whenever my balance is $40 or less to recharge my card this same amount. "

	private documents: any = {
		en: {
			EFL: '',
			TOS: '',
			PDS: '',
			YRAC: ''
		},
		es: {
			EFL: '',
			TOS: '',
			PDS: '',
			YRAC: ''
		}
	};

	public card_max_length: number;
	public credit_debit_number;
	private card_number;
	public expiration_date;
	public ccv;
	public visa_valid: boolean; // 4.
	public master_valid: boolean; // 51 through 55.
	public american_express_valid: boolean; // 37
	public discover_valid: boolean; // 6011 or 65.
	public img: string;
	public card_name: string;
	public add_money_valid;
	public card_holder_name: string;

	// public is_autopay_enable: boolean = undefined;

	public is_autopay_enable: boolean = false;

	public minimum_balance: number;

	private first_recharge_min_amount: number;

	public enroll_with_payment: boolean = false;

	public tnc_class_name: string;

	public is_start_date_today_valid: boolean = false;
	public is_start_date_today_invalid: boolean = false;

	public holidayDates;
	public today;

	public isProcessingEnrollment = false;
	myFilter = (momentDate): boolean => {
		const d = momentDate.toDate();
		const day = d.getDay();
		const today = new Date();
		const calendar_date = this.datePipe.transform(d, 'yyyy-MM-dd');
		const today_date = this.datePipe.transform(today, 'yyyy-MM-dd');
		if (today_date === calendar_date) {
			this.is_start_date_today = true;
			if (today.getHours() >= 18) {
				return false;
			}
		} else {
			this.is_start_date_today = false;
		}
		if (this.holidayDates !== undefined) {
			for (let i = 0; i <= this.holidayDates.length - 1; i++) {
				const holiday_date = this.datePipe.transform(this.holidayDates[i]['event_date'], 'yyyy-MM-dd');
				if (calendar_date === holiday_date) {
					return false;
				}
			}
		}
		return true && day !== 0;
	}
	private non_auto_pay_amount: string;
	autopay_first_recharge_min_amount: any;
	public retries: number;
	public is_readonly_retry:boolean;

	public validPaymentMethod= false;
	primaryPaymentProfile = undefined;
	cvv = undefined;
	isPaymentSuccess = false;
	isWaitingEmailValidation = false;
	paymentReceipt = undefined;
	paymentAmount = undefined;
	processedEnrollment = false;
	public is_valid_number:boolean;
	constructor(
		private fb: FormBuilder,
		private activatedRoute: ActivatedRoute,
		private manageCardsService: ManageCardsService,
		public dialog: MatDialog,
		private sharedService: SharedService,
		private planService: PlanService,
		private customerEnrollService: CustomerEnrollService,
		private localStorageService: LocalStorageService,
		@Inject(SESSION_STORAGE) private sessionStorageService: WebStorageService,
		private router: Router,
		private datePipe: DatePipe,
		private makePaymentService: MakePaymentService,
		private logger: LoggerService,
		private paymentusService: PaymentusService
	) {
		this.retries = 0;
		this.is_readonly_retry = true;

		this.fetchAllDocuments();

		this.sharedService.getIpAddress()
			.then(res => {
				if (res.ip  !== undefined) {
					this.ip_Address = res.ip
				}
			});

		this.customerEnrollService.getHolidayList({ 'tdsp': this.sessionStorageService.get('tdu') })
			.then(res => {
				if (res.status === 'success') {
					this.holidayDates = res.calendar;
					this.today = res.today;
					this.timeover = res.timeover;
				} else {
					this.holidayDates = [];
				}
			});
		this.activatedRoute.params.subscribe((params: Params) => {
			this.setCurrentStep(params['step']);
		});
		this.form = fb.group({
			// passwordFormControl: ['', Validators.compose([Validators.required, Validators.pattern(PASSWORD_REGEX)])],
			passwordFormControl: ['', Validators.compose([Validators.required])],
			confirmPasswordFormControl: ['']
		}, {
			validator: PasswordValidation.MatchPassword
		})
		this.sharedService.setHeaderTitle('default_page');
		this.sharedService.getConfigConst()
			.then(res => {
				if (res.status === 'success') {
					this.first_recharge_min_amount = res.results[0]['firstRechargeMinAmount'];
					this.autopay_first_recharge_min_amount = res.results[0]['firstRechargeMinAmount'];
					this.minimum_balance = res.results[0]['autopayMinBalance'];
					this.autopay_amount = res.results[0]['autopayAmount'];
				}
			});
		// this.sharedService.setHeaderErrorMessage("personal", false, "notification error", "");
		const methodName = this.constructor.name + '.verifyToken';
		let token = this.localStorageService.get('token');
		if (token === null) {
			token = this.localStorageService.get('tempToken');
		}
		this.service_start_upto_days = 0;
		const this_of_obj = this;
		setTimeout(function () {
			if (document.getElementById('which_language').innerHTML === 'English') {
				this_of_obj.laguage_wizard = 'lg-english';
			} else if (document.getElementById('which_language').innerHTML === 'Spanish' ||
				document.getElementById('which_language').innerHTML === 'Español') {
				this_of_obj.laguage_wizard = 'lg-spanish';
			}
		}, 500);


		if (this.localStorageService.get('ProductID') == null) {
			this.router.navigate(['./enroll']);
		}

		// For Date of Birth Date Picker
		this.minDobDate.setFullYear(1905, 1, 1);
		this.maxDobDate.setFullYear(this.maxDobDate.getFullYear() - 18);

		this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);
		let i = 1905;
		for (i = this.maxDate.getFullYear(); i >= 1905; i--) {
			this.years.push({ value: '' + i, viewValue: '' + i });
		}

		this.date = 'Day';
		this.month = 'Month';
		this.year = 'Year';
		this.component_load = true;

		// personal wizard
		const that = this.sharedService;
		setTimeout(function () {
			that.setHeaderErrorMessage('personal', false, 'notification error', '');
			that.setHeaderTitle('personal');
		}, 10);

		// service wizard
		this.is_billing_add_as_service_add = true;
		this.sharedService.getConfigConst()
			.then(res => {
				if (res.status === 'success') {
					this.service_start_upto_days = res.results[0]['serviceStartUptoDays'];
					this.maxDateService.setDate(this.maxDateService.getDate() + (this.service_start_upto_days - 1));
				}
			});
		// this.live_here = false;
		// this.notify_provider = true;
		// this.enroll_service_valid = false;
		this.billing_address_obj = this.localStorageService.get('address_for_billing');
		this.esi_id = this.localStorageService.get('esi_id');
		if (this.billing_address_obj != null) {
			this.billing_address = this.billing_address_obj['address'];
			this.billing_address_2 = '';
			this.city = this.billing_address_obj['city'];
			this.state = this.billing_address_obj['state'];
			this.zip_code = this.billing_address_obj['zipcode'];
		}

		// summary wizard
		this.terms_condition = false;
		this.is_enroll_processing = this.terms_condition;
		this.btn_value = 'Enroll Now';
		this.is_enroll_process = true;
		this.critical_care = false;
		this.is_valid_number =false;
	}

	setCurrentStep(step: string) {
		this.is_enroll_processing = false;
		if (step == undefined) {
			step = "account";
		}

		let data = this.sessionStorageService.get("data_" + step.trim());

		if (step.trim() != "account" && !this.isValidStep(step.trim())) {
			this.router.navigate(['./enrollment-wizard/account']);
		}

		this.goToStep(step, data);
	}

	paymentMethodsUpdated(profiles) {
		console.log(profiles)
		this.primaryPaymentProfile = profiles.length > 0
			? profiles[0] : profiles.length > 1
				? profiles.find((profile) => profile.default)
					? undefined : undefined : undefined;
		this.validPaymentMethod = this.primaryPaymentProfile !== undefined;
		console.log('updated', this.validPaymentMethod)
	}
	fetchAllDocuments() {
		this.planService.getDocument('EFL', 'English')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.en['EFL'] = res.result[0].documentUrl;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('EFL', 'Spanish')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.es['EFL'] = res.result[0].documentUrl;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('TOS', 'English')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.en['TOS'] = res.result[0].documentUrl;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('TOS', 'Spanish')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.es['TOS'] = res.result[0].documentUrl;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('PDS', 'English')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.en['PDS'] = res.result[0].documentUrl;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('PDS', 'Spanish')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.es['PDS'] = res.result[0].documentUrl;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('YRAC', 'English')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.en['YRAC'] = res.result[0].documentUrl;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('YRAC', 'Spanish')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.es['YRAC'] = res.result[0].documentUrl;
					// window.open(res.result[0].document_url, '_blank');
				}
			});
	}

	viewDocument(documentName: string) {
		let lang = document.getElementById('which_language').innerHTML;

		var urlObj;
		if (lang === 'English') {
			urlObj = this.documents.en;
		} else {
			urlObj = this.documents.es;
		}

		window.open(urlObj[documentName], '_blank');
	}

	unmaskData(data: string) {
		if (data != null && data.trim() != "") {
			return data.replace(/[\s\(\)\-]/g, '');
		} else {
			return "";
		}
	}

	// validation of account wizard
	enrollAccountValidate(account: any) {
		if (((this.email != undefined && this.email.match(EMAIL_REGEX))) && this.create_password !== undefined && this.create_password !== '') {
			if (this.create_password.match(PASSWORD_REGEX)) {
				this.enroll_account_valid = true;
			} else {
				this.enroll_account_valid = false;
			}
			if (this.email != undefined && this.email != "") {
				if (!this.email.match(EMAIL_REGEX)) {
					this.enroll_account_valid = false;
				}
			}
			if ((this.phone_number != undefined && this.phone_number != "")) {
				if (!this.mobile_phone_number.match(MOBILE_REGEX)) {
					this.enroll_account_valid = false;
				}
			}
			if (account) {
				if (account.keyCode === 13) {
					document.getElementById('btn-click-account').click();
				}
			}
		} else {
			this.has_contact_info = !((this.phone_number == undefined || this.phone_number == '')
				&&
				(this.email == undefined || this.email == ''));
			this.enroll_account_valid = false;
		}
	}

	// validation of account wizard
	enrollPhoneNumberValidate(account: any) {
		this.sharedService.setHeaderErrorMessage('personal', false, 'notification error', '');
		this.is_valid_number =false;
		if (this.mobile_phone_number != undefined) {
			this.phone_number = this.unmaskData(this.mobile_phone_number);
		} else {
			this.phone_number = undefined;
		}
		if(this.phone_number != undefined && this.mobile_phone_number.match(MOBILE_REGEX)){
			this.lookupPhoneNumber();
		}
		else {
			this.has_contact_info = !((this.phone_number == undefined || this.phone_number == '')
				&&
				(this.email == undefined || this.email == ''));
			this.enroll_account_valid = false;
		}
	}


	createEnrollAccount() {
		this.sharedService.setHeaderErrorMessage('personal', false, 'notification error', '');
		if (!this.create_password.match(PASSWORD_REGEX)) {
			this.invalid_password = true;
			this.msg_class = "password_error";
			document.getElementById("password").classList.add("password_input_error");
		} else if (this.phone_number != undefined && this.phone_number !== '' && !this.mobile_phone_number.match(MOBILE_REGEX)) {
			this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'Please enter valid 10 digit mobile no.');
		}else if (this.email != undefined && this.email !== '' && !this.email.match(EMAIL_REGEX)) {
			this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'Please enter valid Email.');
		} else {
			this.checkEmailExists();
		}
	}

	async lookupPhoneNumber(){
		this.is_valid_number = false;
		let lookupResponse = await this.customerEnrollService.lookupPhoneNumber({phoneNumber: this.phone_number});


		if(lookupResponse["type"] != "mobile"){
			this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'The phone number provided is not capable to receiving messages.  Please consider changing to a mobile number that can receive messages.');
		}
		else{
			this.sharedService.setHeaderErrorMessage('personal', false, 'notification error', '');
			this.is_valid_number = true;
		}
	}

	checkMobileExists() {
		if (this.phone_number != undefined && this.phone_number.trim() != '' && this.mobile_phone_number.match(MOBILE_REGEX)) {
			this.customerEnrollService.checkMobileNoAlreadyRegister({ 'mobilePhoneNumber': this.phone_number, 'isEnrollRequest': true }).then(res => {
				// if (res.status === 'success') {
				if (!res.isExists) {
					this.is_mobile_no_exist = false;

					let data = {
						'password': this.create_password,
						'phone_number': this.mobile_phone_number,
						'email': this.email
					};
					this.sessionStorageService.set('data_account', data);
					// this.goToStep('personal');
					this.router.navigate(['./enrollment-wizard/personal']);
				} else {
					this.is_mobile_no_exist = true;
				}
				// }

			});
		} else {
			let data = {
				'password': this.create_password,
				'phone_number': this.phone_number,
				'email': this.email
			};
			this.sessionStorageService.set('data_account', data);
			// this.goToStep('personal');
			this.router.navigate(['./enrollment-wizard/personal']);
		}

		if (this.phone_number == undefined || this.phone_number.trim() == '') {
			this.is_mobile_no_exist = false;
		}

		if (this.email == undefined || this.email.trim() == '') {
			this.is_email_exist = false;
		}
	}

	checkEmailExists() {
		if (this.email != undefined && this.email.trim() != '' && this.email.match(EMAIL_REGEX)) {
			this.customerEnrollService.checkEmailAlreadyRegister({ 'email': this.email, 'isEnrollRequest': true}).then(res => {
				// if (res.status === 'success') {
				if (!res.isExists) {
					this.is_email_exist = false;

					this.checkMobileExists();
				} else {
					this.is_email_exist = true;
					// this.sharedService.setHeaderErrorMessage('personal', true, 'notification error',
					//   'This email is currently in use on an existing account.  Please enter a different email or call us at 888.764.6669.');
				}
				// }

			});
		} else {
			this.checkMobileExists();
		}
		if (this.phone_number == undefined || this.phone_number.trim() == '') {
			this.is_mobile_no_exist = false;
		}

		if (this.email == undefined || this.email.trim() == '') {
			this.is_email_exist = false;
		}
	}

	check_date(event) {
	}

	dob_typing_change(event){
		const input = <HTMLInputElement>document.getElementById('date_dob');
		var test_value = input.value;
		if(event.key !== "Backspace"){
			var conformedDate = conformToMask(input.value, this.dateMask, {guide : false}).conformedValue;

			var slashCount = 0;
			for(var i = 0; i < input.value.length; i++){
				if(input.value.charAt(i) == '/'){
					slashCount++;
				}
			}

			if(conformedDate[conformedDate.length - 1] !== '/' && slashCount < 2){
				(<HTMLInputElement>document.getElementById('date_dob')).value = conformedDate;
				test_value = conformedDate;
			}
		}
		this.check_dob_validity(test_value, event);
	}

	dob_select_change(event) {
		const input = <HTMLInputElement>document.getElementById('date_dob');
		this.check_dob_validity(input.value, event);
	}

	check_dob_validity(test_value, event){
		this.is_dob_valid = !!(event !== undefined &&
			test_value.length > 5 &&
			dateRegex.test(test_value)
		);

		if (this.date_dob !== undefined && this.is_dob_valid) {
			this.acc_pin = this.datePipe.transform(this.date_dob, 'MMdd');
		}
		this.enrollPersonalValidate(event);
	}

	service_date_select_change(event) {
		const input = <HTMLInputElement>document.getElementById('serviceStartDateInput');

		this.is_service_start_valid = !!(event !== undefined &&
			input.value.length > 5 &&
			dateRegex.test(input.value)
		);

		if (this.moment_start_date !== undefined) {
			this.is_filtered_date = !this.myFilter(this.moment_start_date);
			this.is_past_start_date = this.moment_start_date < this.minDate;
		}

		if (this.is_service_start_valid) {
			this.service_start_date = this.moment_start_date;
			input.value = moment(this.moment_start_date).format('MM/DD/YYYY');
		}

		this.enrollServiceValidate(event);
	}

	// Validation of personal wizard
	enrollPersonalValidate(personal: any) {
		var dateinput = <HTMLInputElement>document.getElementById('date_dob');
		this.first_name = this.first_name.trim().length > 0 ? this.first_name : this.first_name.trim();
		this.last_name = this.last_name.trim().length > 0 ? this.last_name : this.last_name.trim();
		if (this.first_name != undefined && this.first_name.trim() != ''  &&
			this.last_name != undefined && this.last_name.trim() != ''
			&& this.date_dob != undefined && dateRegex.test(dateinput.value) && this.acc_pin != undefined && this.acc_pin.trim() != '' && this.acc_pin.match(PIN_REGEX)) {
			this.enroll_personal_valid = true;
			if (personal) {
				if (personal.keyCode == 13) {
					document.getElementById('btn-click-personal').click();
				}
			}
		} else {
			this.enroll_personal_valid = false;
		}
	}

	createEnrollPersonal() {
		this.sharedService.setHeaderErrorMessage('personal', false, 'notification error', '');
		if (this.first_name == undefined) {
			this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'Please enter valid first name.');
		} else if (this.last_name == undefined) {
			this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'Please enter valid last name.');
		} else {
			let data = {
				'first_name': this.first_name,
				'last_name': this.last_name,
				'date_dob': this.date_dob,
				'acc_pin': this.acc_pin,
				'prefered_language': this.prefered_language
			};
			this.sessionStorageService.set('data_personal', data);
			this.router.navigate(['./enrollment-wizard/service']);
			// this.goToStep('service');
		}
	}

	confirmPasswordMatch(event: any) {
		if (this.create_password !== '' && event.keyCode !== 13) {
			this.confirm_password = '';
		}
	}

	// service wizard method
	enrollServiceValidate(service: any) {
		console.log(service)
		if (this.live_here) {
			if (this.notify_provider) {
				this.service_type = 'Move-In';//move
			} else {
				this.service_type = 'Old-User';//switch
			}
		} else {
			this.service_type = 'Move-In';//move
		}

		if (this.is_service_start_valid && this.service_start_date) {
			this.service_start_date = moment(this.service_start_date).toDate();

			const today = new Date();
			const service_date = this.datePipe.transform(this.service_start_date, 'yyyy-MM-dd');
			const today_date = this.datePipe.transform(today, 'yyyy-MM-dd');

			this.is_start_date_today_valid = service_date === today_date && today.getHours() < 18;
			this.is_start_date_today_invalid = service_date === today_date && today.getHours() >= 18;
		}

		if (this.service_type !== '' && this.billing_address !== '' && this.city !== '' &&
			this.state !== '' && this.zip_code !== '' && this.service_type !== undefined &&
			this.service_start_date !== undefined && this.billing_address !== undefined &&
			this.city !== undefined && this.state !== undefined && this.zip_code !== undefined &&
			this.service_start_date != null &&
			this.state.match(LETTERS_REGEX) && this.zip_code.match(ZIPCODE_REGEX) &&
			this.is_service_start_valid && !this.is_filtered_date && !this.is_past_start_date) {
			this.enroll_service_valid = true;
			this.date_service_start = this.service_start_date.getFullYear() + '-' +
				(this.service_start_date.getMonth() + 1) + '-' + this.service_start_date.getDate();
			this.sessionStorageService.set('service_start_date', this.service_start_date);
			if (service) {
				if (service.keyCode === 13) {
					document.getElementById('btn-click-service').click();
				}
			}
		} else {
			this.enroll_service_valid = false;
		}
	}

	enrollPaymentAddressValidate(service: any) {
		if (this.live_here) {
			if (this.notify_provider) {
				this.service_type = 'Move-In';//move
			} else {
				this.service_type = 'Old-User';//switch
			}
		} else {
			this.service_type = 'Move-In';//move
		}

		if (this.service_start_date != undefined) {
			const today = new Date();
			const service_date = this.datePipe.transform(this.service_start_date, 'yyyy-MM-dd');
			const today_date = this.datePipe.transform(today, 'yyyy-MM-dd');

			this.is_start_date_today_valid = service_date === today_date && today.getHours() < 18;
			this.is_start_date_today_invalid = service_date === today_date && today.getHours() >= 18;
		}

		if (this.service_type !== '' && this.billing_address !== '' && this.city !== '' &&
			this.state !== '' && this.zip_code !== '' && this.service_type !== undefined &&
			this.service_start_date !== undefined && this.billing_address !== undefined &&
			this.city !== undefined && this.state !== undefined && this.zip_code !== undefined &&
			this.service_start_date != null && this.city.match(LETTERS_REGEX) &&
			this.state.match(LETTERS_REGEX) && this.zip_code.match(ZIPCODE_REGEX) && this.terms_condition) {
			this.is_enroll_processing = true;
			this.date_service_start = this.service_start_date.getFullYear() + '-' +
				(this.service_start_date.getMonth() + 1) + '-' + this.service_start_date.getDate();
			this.sessionStorageService.set('service_start_date', this.service_start_date);
			if (service) {
				if (service.keyCode === 13) {
					document.getElementById('btn-click-service').click();
				}
			}
		} else {
			this.is_enroll_processing = false;
		}
	}

	createEnrollService() {
		const data = {
			'live_here': this.live_here,
			'notify_provider': this.notify_provider,
			'service_type': this.service_type,
			'service_start_date': this.service_start_date,
			'billing_address': this.billing_address,
			'city': this.city,
			'state': this.state,
			'zip_code': this.zip_code,
			'date_service_start': this.date_service_start,
		};
		this.sessionStorageService.set('data_service', data);

		// Pre-enroll first so the Amber account + token exist, then run the identity (trust)
		// check, which the Amber API proxies to the trust service. A "Cash" result routes the
		// customer to the "Cash Only" page; "Any" (or any failure, which fails open) continues
		// to the normal Charge Up step.
		this.preEnrollCustomer().then(_ => {
			// Pre-enroll failed (no token) — its error message is already shown, so stop here.
			if (!this.localStorageService.get('tempToken')) {
				return;
			}
			// Keep the loading screen up through the trust check so step 3 doesn't flash back.
			this.component_load = false;
			this.sharedService.setLoader('summary', true);
			const verifyRequest = {
				'token': this.localStorageService.get('tempToken'),
				'CustomerInfo': {
					'FirstName': this.first_name,
					'LastName': this.last_name,
					'MiddleName': '',
					'DateOfBirth': this.datePipe.transform(this.date_dob, 'yyyy-MM-dd'),
					'Email': this.email,
					'Phone': this.unmaskData(this.mobile_phone_number),
					'StreetAddress': this.billing_address,
					'City': this.city,
					'State': this.state,
					'ZipCode': this.zip_code
				}
			};
			// A failed check (the call errors, or the API reports status 'fail') is retried once. If the
			// retry fails too, continue as before: fraud prevention is best effort and never blocks
			// enrollment, and the API re-checks with the trust service when enrollment completes.
			const verifyIdentity = () => this.customerEnrollService.verifyIdentity(verifyRequest)
				.then(res => (res && res.status !== 'fail') ? res : Promise.reject(res));
			return verifyIdentity().catch(_ => verifyIdentity()).catch(_ => undefined).then((res) => {
				// Persist the verdict so the cash "Enroll Now" on the policy page (reached after a
				// full page reload) can tell the backend to mark the account cash-only.
				const cashOnly = !!(res && res.cashOnly);
				this.sessionStorageService.set('is_cash_only', cashOnly);
				const target = cashOnly ? './enrollment-wizard/cash_only' : './enrollment-wizard/pre_payment';
				return this.router.navigate([target]);
			}).then(() => {
				// New step is active — reveal it and drop the loader.
				this.component_load = true;
				this.sharedService.setLoader('summary', false);
			});
		}).catch(_ => {
			this.component_load = true;
			this.sharedService.setLoader('summary', false);
		});
	}

	// "Continue with enrollment" from the Cash Only page -> pay with cash Terms & Conditions.
	continueWithCashEnrollment() {
		this.sharedService.scrollToTopSmoothly();
		window.location.href = './enrollment-wizard/policy';
	}

	// "Cancel enrollment" from the Cash Only page -> delete/inactivate the Amber account,
	// sign the customer out, clear the enrollment stepper and drop them back on /enroll.
	cancelCashOnlyEnrollment() {
		let token: string = this.localStorageService.get('token');
		if (!token) {
			token = this.localStorageService.get('tempToken');
		}

		const cleanupAndExit = () => {
			this.sharedService.setHeaderUserLoggedIn('sign_in', false, null);
			this.localStorageService.remove('token');
			this.localStorageService.remove('tempToken');
			this.localStorageService.remove('name');
			this.localStorageService.remove('billingAccountNumber');
			this.sessionStorageService.remove('data_account');
			this.sessionStorageService.remove('data_personal');
			this.sessionStorageService.remove('data_service');
			this.sessionStorageService.remove('is_cash_only');
			// Hard navigate so the wizard component (and its stepper state) is fully torn down.
			window.location.href = '/enroll';
		};

		// Stubbed cancel endpoint + sign out. Clean up and redirect regardless of outcome.
		this.customerEnrollService.cancelEnrollment({ token })
			.then(() => this.sharedService.signOut({ token }))
			.catch(() => { /* best-effort: still clean up locally */ })
			.then(cleanupAndExit);
	}

	createEnrollPayment() {
		this.sharedService.scrollToTopSmoothly();
		// this.goToStep('payment');

		this.router.navigate(['./enrollment-wizard/payment']);

	}

	createEnrollPolicy() {
		this.sharedService.scrollToTopSmoothly();
		// this.goToStep('policy');

		window.location.href = './enrollment-wizard/policy';


	}

	ngOnInit() {
		this.localStorageService.set('is_express_pay', false);
		const len = document.getElementsByTagName('body')[0];
		if (len !== undefined) {
			if (len.classList.contains('body_autocomplete')) {
				len.classList.remove('body_autocomplete');
			}
		}

		setTimeout(function () {
			const setPos = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-container')[0];
			if (setPos !== undefined) {
				if (setPos.classList.contains('cdk-overlay-container-static')) {
					setPos.classList.remove('cdk-overlay-container-static');
				}
			}
		}, 10);
	}
	preEnrollCustomer() {
		this.customer_enroll_object = {
			'critical_care': this.critical_care,
			'first_name': this.first_name,
			'last_name': this.last_name,
			'mobile_phone_number': this.unmaskData(this.mobile_phone_number),
			'email': this.email,
			'date_of_birth': this.datePipe.transform(this.date_dob, 'yyyy-MM-dd'),
			'acc_pin': this.acc_pin,
			'create_password': this.create_password,
			'confirm_password': this.create_password,
			'prefered_lang': this.prefered_language,
			'service_type': this.service_type,
			'service_start_date': '' + this.date_service_start,
			'billing_address': this.billing_address.trim(),
			'billing_address_2': this.billing_address_2.trim(),
			'city': this.city.trim(),
			'state': this.state.trim(),
			'live_here': this.live_here,
			'notify_provider': this.notify_provider,
			'zip_code': this.zip_code,
			'service_address': this.billing_address_obj['address'],
			'service_address_2': '',
			'service_city': this.billing_address_obj['city'],
			'service_state': this.billing_address_obj['state'],
			'service_zip_code': this.billing_address_obj['zipcode'],
			'esi_id': this.billing_address_obj['esiId'],
			'IPAddress' : this.ip_Address,
		};
		this.component_load = false;
		this.btn_value = 'Enrolling...';
		this.disable_div = 'disable-div';
		this.is_enroll_processing = false;
		this.is_enroll_process = false;
		this.sharedService.setLoader('summary', true);
		const methodName = this.constructor.name + '.createCustEnroll';
		return this.customerEnrollService.preEnrollCustomer(this.customer_enroll_object).then(res => {
			this.customer_enroll_object['create_password'] = '[masked]';
			this.customer_enroll_object['confirm_password'] = '[masked]';
			const logObj = {
				method: methodName,
				request: this.customer_enroll_object,
				response: res
			};
			this.logger.logInfo(JSON.stringify(logObj));
			if (res.status === 'success') {
				console.log(res, res.token)
				this.localStorageService.set('tempToken', res.token);
				this.btn_value = 'Enroll Now'
				this.component_load = true;
				this.sharedService.setLoader('summary', false);
			}
		}, (error) => {
			this.component_load = true;
			console.log('err', error);
			this.sharedService.setLoader('summary', false);
			this.sharedService.setHeaderErrorMessage('summary', true, 'notification error', error._body);
			const logObj = {
				method: methodName,
				request: this.customer_enroll_object,
				exception: error
			};
			this.logger.logError(JSON.stringify(logObj));
		}).catch((ex) => {
			console.log('ex', ex);
			const logObj = {
				method: methodName,
				request: this.customer_enroll_object,
				exception: ex
			};
			this.logger.logError(JSON.stringify(logObj));
		});
	}
	createEnrollmentAccount() {
		this.component_load = false;
		this.isProcessingEnrollment = true;
		this.sharedService.setLoader('summary', true);
		let token: string = this.localStorageService.get('token');
		if (!token) {
			token = this.localStorageService.get('tempToken');
		}
		this.sharedService.scrollToTopSmoothly();
		this.sharedService.setHeaderTitle('enrolling_now')
		this.sharedService.setLoader('enrolling_now', true);
		this.customerEnrollService.completeEnrollment({
			token,
			paymentToken: this.enroll_with_payment ? this.primaryPaymentProfile.token : '',
			paymentAmount: this.paymentAmount,
			'critical_care': this.critical_care,
			'first_name': this.first_name,
			'last_name': this.last_name,
			'mobile_phone_number': this.unmaskData(this.mobile_phone_number),
			'email': this.email,
			'date_of_birth': this.datePipe.transform(this.date_dob, 'yyyy-MM-dd'),
			'acc_pin': this.acc_pin,
			'create_password': this.create_password,
			'confirm_password': this.create_password,
			'prefered_lang': this.prefered_language,
			'service_type': this.service_type,
			'service_start_date': '' + this.date_service_start,
			'billing_address': this.billing_address.trim(),
			'billing_address_2': this.billing_address_2.trim(),
			'city': this.city.trim(),
			'state': this.state.trim(),
			'live_here': this.live_here,
			'notify_provider': this.notify_provider,
			'zip_code': this.zip_code,
			'service_address': this.billing_address_obj['address'],
			'service_address_2': '',
			'service_city': this.billing_address_obj['city'],
			'service_state': this.billing_address_obj['state'],
			'service_zip_code': this.billing_address_obj['zipcode'],
			'esi_id': this.billing_address_obj['esiId'],
			'IPAddress' : this.ip_Address,
			IsAutoPay: this.is_autopay_enable === true,
			SavePaymentProfile: this.isSavePaymentProfile,
			Cvv: this.cvv,
			StartWithCash: !this.enroll_with_payment,
			CashOnly: this.sessionStorageService.get('is_cash_only') === true
		}).then((res) => {
			const logObj = {
				method: this.constructor.name + '.paymentPay',
				request: {
					token: '[masked]',
					PaymentAmount: this.amountFormControl.value,
					PaymentMethodToken: this.enroll_with_payment ? this.primaryPaymentProfile.token : ''
				},
				response: res
			};
			this.logger.logInfo(JSON.stringify(logObj));
			if (res.status === 'success') {
				this.completeEnrollment();
			} else {
				this.sharedService.setHeaderErrorMessage('pay_credit_debit', true, 'notification error', res.message);
				this.isProcessingEnrollment = false;
			}
			this.component_load = true;
			this.sharedService.setLoader('summary', false);
		});
	}
	completeEnrollment() {
		this.isProcessingEnrollment = true;
		let token: string = this.localStorageService.get('token');
		if (!token) {
			token = this.localStorageService.get('tempToken');
		}
		const methodName = this.constructor.name + '.createCustEnroll';
		this.sessionStorageService.remove('data_account');
		this.sessionStorageService.remove('data_personal');
		this.sessionStorageService.remove('data_service');
		this.sessionStorageService.remove('is_cash_only');
		this.sharedService.verifyToken({token})
			.then((res) => {
				const logObj = {
					method: methodName,
					request: 'token : [masked]',
					response: res
				};
				this.logger.logInfo(JSON.stringify(logObj));
				if (res.status === 'success' && res.isTerminated === false) {
					const person = res.results[0]['personal'][0];
					const dataLayerEvent = 'enroll - success';
					(window as any).dataLayer.push({
						'event': dataLayerEvent,
						'accountID': person.id.toString(),
						'accountNumber': person.accountNumber.toString(),
						'is_cash_payment': !this.enroll_with_payment
					});
					this.processedEnrollment = true;
					this.isWaitingEmailValidation = true;
				}
				this.isProcessingEnrollment = false;
			});
		this.component_load = true;
		this.sharedService.setLoader('summary', false);
		this.localStorageService.set('token', token) // fixes redirect

		if (!this.enroll_with_payment) {
			this.router.navigate(['./make-first-payment/cash']);
		}
	}
	fixCalendarTranslate() {
		const calendar = <HTMLScriptElement>document.getElementsByClassName('mat-datepicker-content')[0];

		if (calendar !== undefined && !calendar.classList.contains('notranslate')) {
			calendar.classList.add('notranslate');
		}
	}

	setStatus(event) {
		this.terms_condition = event.checked;
	}

	setAutopayEnabled(event) {
		this.is_autopay_enable = event.checked;
	}

	goToStep(step: string, data: any = null) {
		this.doing_personal = '';
		this.doing_account = '';
		this.doing_service = '';
		this.doing_payment = '';
		this.complete_personal = '';
		this.complete_account = '';
		this.complete_service = '';
		this.complete_payment = '';
		this.is_doing_personal = false;
		this.is_doing_account = false;
		this.is_doing_service = false;
		this.is_doing_cash_only = false;
		this.is_doing_pre_payment = false;
		this.is_doing_payment = false;
		this.is_completed_personal = false;
		this.is_completed_account = false;
		this.is_completed_service = false;
		this.is_completed_pre_payment = false;
		this.is_completed_payment = false;

		switch (step) {
			case 'account': {
				var dataLayerEvent = 'enroll - step 1';
				(window as any).dataLayer.push({ 'event': dataLayerEvent });
				this.doing_account = 'doing';
				this.is_doing_account = true;

				if (data != undefined) {
					this.create_password = data.password.trim();
					this.mobile_phone_number = data.phone_number.trim();
					this.email = data.email.trim();
				} else {
					this.create_password = "";
					this.mobile_phone_number = "";
					this.email = "";
				}

				this.enrollAccountValidate(null);

				this.sharedService.scrollToTopSmoothly();

				break;
			}
			case 'personal': {
				var dataLayerEvent = 'enroll - step 2';
				(window as any).dataLayer.push({ 'event': dataLayerEvent });
				this.doing_personal = 'doing';
				this.is_doing_personal = true;
				this.complete_account = 'complete';
				this.is_completed_account = true;

				if (data != undefined) {
					this.first_name = data.first_name;
					this.last_name = data.last_name;
					this.date_dob = new Date(data.date_dob);
					this.acc_pin = data.acc_pin;
					this.prefered_language = data.prefered_language;


					let acc_data = this.sessionStorageService.get('data_account');
					this.create_password = acc_data.password.trim();
					this.mobile_phone_number = acc_data.phone_number.trim();
					this.email = acc_data.email.trim();

				} else {
					this.first_name = "";
					this.last_name = "";
					this.date_dob = null;
					this.acc_pin = "";
					this.prefered_language = "English";
				}

				this.enrollPersonalValidate(null);

				this.sharedService.scrollToTopSmoothly();
				break;
			}
			case 'service': {
				var dataLayerEvent = 'enroll - step 3';
				(window as any).dataLayer.push({ 'event': dataLayerEvent });
				this.doing_service = 'doing';
				this.complete_personal = 'complete';
				this.complete_account = 'complete';
				this.is_doing_service = true;
				this.is_completed_personal = true;
				this.is_completed_account = true;

				if (data != undefined) {
					this.live_here = data.live_here;
					this.notify_provider = data.notify_provider;
					this.service_type = data.service_type;
					this.service_start_date = new Date(data.service_start_date);
					this.date_service_start = data.date_service_start;


					let acc_data = this.sessionStorageService.get('data_account');
					this.create_password = acc_data.password.trim();
					this.mobile_phone_number = acc_data.phone_number.trim();
					this.email = acc_data.email.trim();

					let personal_data = this.sessionStorageService.get('data_personal');
					this.first_name = personal_data.first_name;
					this.last_name = personal_data.last_name;
					this.date_dob = new Date(personal_data.date_dob);
					this.acc_pin = personal_data.acc_pin;
					this.prefered_language = personal_data.prefered_language;



				} else {
					this.live_here = false;
					this.notify_provider = true;
					this.service_type = "";
					this.service_start_date = null;
					this.date_service_start = "";
				}

				this.enrollServiceValidate(null);

				this.sharedService.scrollToTopSmoothly();
				break;
			}
			case 'cash_only': {
				var dataLayerEvent = 'enroll - cash only';
				(window as any).dataLayer.push({ 'event': dataLayerEvent });
				this.complete_personal = 'complete';
				this.complete_account = 'complete';
				this.complete_service = 'complete';
				this.is_doing_cash_only = true;
				this.is_completed_personal = true;
				this.is_completed_account = true;
				this.is_completed_service = true;

				let acc_data = this.sessionStorageService.get('data_account');
				this.create_password = acc_data.password.trim();
				this.mobile_phone_number = acc_data.phone_number.trim();
				this.email = acc_data.email.trim();

				let personal_data = this.sessionStorageService.get('data_personal');
				this.first_name = personal_data.first_name;
				this.last_name = personal_data.last_name;
				this.date_dob = new Date(personal_data.date_dob);
				this.acc_pin = personal_data.acc_pin;
				this.prefered_language = personal_data.prefered_language;

				let service_data = this.sessionStorageService.get('data_service');
				this.live_here = service_data.live_here;
				this.notify_provider = service_data.notify_provider;
				this.service_type = service_data.service_type;
				this.service_start_date = new Date(service_data.service_start_date);
				this.date_service_start = service_data.date_service_start;

				this.sharedService.scrollToTopSmoothly();
				break;
			}
			case 'pre_payment': {
				var dataLayerEvent = 'enroll - step 4';
				(window as any).dataLayer.push({ 'event': dataLayerEvent });
				this.doing_payment = 'doing';
				this.complete_personal = 'complete';
				this.complete_account = 'complete';
				this.complete_service = 'complete';
				this.is_doing_pre_payment = true;
				this.is_completed_personal = true;
				this.is_completed_account = true;
				this.is_completed_service = true;

				let acc_data = this.sessionStorageService.get('data_account');
				this.create_password = acc_data.password.trim();
				this.mobile_phone_number = acc_data.phone_number.trim();
				this.email = acc_data.email.trim();

				let personal_data = this.sessionStorageService.get('data_personal');
				this.first_name = personal_data.first_name;
				this.last_name = personal_data.last_name;
				this.date_dob = new Date(personal_data.date_dob);
				this.acc_pin = personal_data.acc_pin;
				this.prefered_language = personal_data.prefered_language;

				let service_data = this.sessionStorageService.get('data_service');
				this.live_here = service_data.live_here;
				this.notify_provider = service_data.notify_provider;
				this.service_type = service_data.service_type;
				this.service_start_date = new Date(service_data.service_start_date);
				this.date_service_start = service_data.date_service_start;
				this.sharedService.scrollToTopSmoothly();
				break;
			}
			case 'payment': {
				var dataLayerEvent = 'enroll - step 4';
				(window as any).dataLayer.push({ 'event': dataLayerEvent });
				this.doing_payment = 'doing';
				this.complete_personal = 'complete';
				this.complete_account = 'complete';
				this.complete_service = 'complete';
				this.tnc_class_name = 'tnc_box';
				this.is_doing_payment = true;
				this.is_completed_personal = true;
				this.is_completed_account = true;
				this.is_completed_service = true;
				this.enroll_with_payment = true;
				this.is_completed_pre_payment = true;
				this.card_holder_name = null;
				this.credit_debit_number = null;
				this.expiration_date = null;
				this.ccv = null;
				this.billing_zip_code = null;
				this.amount = this.first_recharge_min_amount.toString();



				let acc_data = this.sessionStorageService.get('data_account');
				this.create_password = acc_data.password.trim();
				this.mobile_phone_number = acc_data.phone_number.trim();
				this.email = acc_data.email.trim();

				let personal_data = this.sessionStorageService.get('data_personal');
				this.first_name = personal_data.first_name;
				this.last_name = personal_data.last_name;
				this.date_dob = new Date(personal_data.date_dob);
				this.acc_pin = personal_data.acc_pin;
				this.prefered_language = personal_data.prefered_language;

				let service_data = this.sessionStorageService.get('data_service');
				this.live_here = service_data.live_here;
				this.notify_provider = service_data.notify_provider;
				this.service_type = service_data.service_type;
				this.service_start_date = new Date(service_data.service_start_date);
				this.date_service_start = service_data.date_service_start;



				this.ccvFormControl.markAsUntouched();
				this.cardFormControl.markAsUntouched();
				this.expirationDateFormControl.markAsUntouched();
				this.sharedService.scrollToTopSmoothly();
				break;
			}
			case 'policy': {
				var dataLayerEvent = 'enroll - step 4';
				(window as any).dataLayer.push({ 'event': dataLayerEvent });
				this.doing_payment = 'doing';
				this.complete_personal = 'complete';
				this.complete_account = 'complete';
				this.complete_service = 'complete';
				this.tnc_class_name = 'tnc_box_long';
				this.enroll_with_payment = false;
				this.is_doing_payment = true;
				this.is_completed_personal = true;
				this.is_completed_account = true;
				this.is_completed_service = true;
				this.is_completed_pre_payment = true;

				let acc_data = this.sessionStorageService.get('data_account');
				this.create_password = acc_data.password.trim();
				this.mobile_phone_number = acc_data.phone_number.trim();
				this.email = acc_data.email.trim();

				let personal_data = this.sessionStorageService.get('data_personal');
				this.first_name = personal_data.first_name;
				this.last_name = personal_data.last_name;
				this.date_dob = new Date(personal_data.date_dob);
				this.acc_pin = personal_data.acc_pin;
				this.prefered_language = personal_data.prefered_language;

				let service_data = this.sessionStorageService.get('data_service');
				this.live_here = service_data.live_here;
				this.notify_provider = service_data.notify_provider;
				this.service_type = service_data.service_type;
				this.service_start_date = new Date(service_data.service_start_date);
				this.date_service_start = service_data.date_service_start;



				this.sharedService.scrollToTopSmoothly();
				break;
			}
			default: {
				var dataLayerEvent = 'enroll - step 1';
				(window as any).dataLayer.push({ 'event': dataLayerEvent });
				this.doing_account = 'doing';
				this.is_doing_account = true;
				this.sharedService.scrollToTopSmoothly();
				break;
			}
		}
	}

	isValidStep(step: string) {
		let is_valid_step = false;
		switch (step) {
			case 'account': {
				is_valid_step = true;
				break;
			}
			case 'personal': {
				let accData = this.sessionStorageService.get("data_account");
				is_valid_step = accData != undefined;
				break;
			}
			case 'service': {
				let accData = this.sessionStorageService.get("data_account");
				let perData = this.sessionStorageService.get("data_personal");
				is_valid_step = accData != undefined && perData != undefined;
				break;
			}
			case 'cash_only': {
				let accData = this.sessionStorageService.get("data_account");
				let perData = this.sessionStorageService.get("data_personal");
				let serData = this.sessionStorageService.get("data_service");
				is_valid_step = accData != undefined && perData != undefined && serData != undefined;
				break;
			}
			case 'pre_payment': {
				let accData = this.sessionStorageService.get("data_account");
				let perData = this.sessionStorageService.get("data_personal");
				let serData = this.sessionStorageService.get("data_service");
				is_valid_step = accData != undefined && perData != undefined && serData != undefined;
				break;
			}
			case 'payment': {
				let accData = this.sessionStorageService.get("data_account");
				let perData = this.sessionStorageService.get("data_personal");
				let serData = this.sessionStorageService.get("data_service");
				is_valid_step = accData != undefined && perData != undefined && serData != undefined;
				break;
			}
			case 'policy': {
				let accData = this.sessionStorageService.get("data_account");
				let perData = this.sessionStorageService.get("data_personal");
				let serData = this.sessionStorageService.get("data_service");
				is_valid_step = accData != undefined && perData != undefined && serData != undefined;
				break;
			}
			default: {
				is_valid_step = false;
				break;
			}
		}

		return is_valid_step;
	}

	mobilePhoneInfo() {
		// this.dialog.open(MobilePhoneInfo);
		this.dialog.open(InfoDialog, {
			data: {
				title: "Why we need your mobile phone number",
				message: "You will use this number to sign into your account. We will use this number to send you important alerts about your balance and your account. We will not sell your phone number to 3rd parties. We hate SPAM as much as you do. (Text message and data rates may apply.)"
			}
		});
	}

	dateOfBirthInfo() {
		// this.dialog.open(DateOfBirthInfo);
		this.dialog.open(InfoDialog, {
			data: {
				title: "Why We Ask For Your Date of Birth",
				message: "You must be at least 18 years of age to enroll with Pogo Energy (that’s a PUCT regulation, not Pogo)."
			}
		});
	}

	pinInfo() {
		// this.dialog.open(DateOfBirthInfo);
		this.dialog.open(InfoDialog, {
			data: {
				title: "Why We Ask For Account PIN",
				message: "You’ll need this to verify your identity if you ever need to talk with a Pogo representative. The default PIN is your birth month and day. You can change this now or later in your ‘My Account’ settings once you’ve set up an account."
			}
		});
	}

	serviceDateInfo() {
		// this.dialog.open(DateOfBirthInfo);
		this.dialog.open(InfoDialog, {
			data: {
				title: "Why We Ask For Service Start Date",
				message: "When you want your service to start with Pogo Energy is up to you so you’ll need to tell us. Just let us know and we’ll get your power turned on with Pogo – even if it’s today."
			}
		});
	}

	chargeupAccountInfo() {
		// this.dialog.open(DateOfBirthInfo);
		this.dialog.open(InfoDialog, {
			data: {
				title: "Why We Ask To Charge Up Your Account Now",
				message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nec dapibus neque. Morbi varius a sapien fringilla bibendum. Quisque dignissim."
			}
		});
	}

	addMoneyInfo() {
		// this.dialog.open(DateOfBirthInfo);
		this.dialog.open(InfoDialog, {
			data: {
				title: "Why We Ask To Add Money To Your Account",
				message: "You have to charge up your account so we can get you started on Pogo power (not us, it’s a PUC regulation)."
			}
		});
	}

	cvvInfo() {
		// this.dialog.open(DateOfBirthInfo);
		this.dialog.open(InfoDialog, {
			data: {
				title: "Why We Ask For CVV",
				message: "That little number on the back of your card"
			}
		});
	}

	autoPayFailInfo() {
		// this.dialog.open(DateOfBirthInfo);
		let dialogRef = this.dialog.open(InfoDialog, {
			data: {
				title: "Autopay setup failed",
				message: "Oops! Autopay setup failed. Though don\'t worry, you can set up Autopay anytime later, using Manage Card Section."
			}
		});
		dialogRef.afterClosed().subscribe((result) => {
			this.is_enroll_processing = true;
			this.is_enroll_process = true;
			this.disable_div = '';
			this.router.navigate(['./congrats']);
		});
	}

	updateEmailVerified(verified: boolean) {
		this.email_verified = verified;
		if (!verified) {
			return;
		}
		let token: string = this.localStorageService.get('token');
		if (!token) {
			token = this.localStorageService.get('tempToken');
		}
		this.is_doing_payment = true;
		this.isProcessingEnrollment = true;
		this.sharedService.scrollToTopSmoothly();
		this.sharedService.setHeaderTitle('enrolling_now')
		this.sharedService.setLoader('enrolling_now', true);
		this.isWaitingEmailValidation = false;
		this.customerEnrollService.completeEnrollmentPayment({
				token,
				paymentToken: this.enroll_with_payment ? this.primaryPaymentProfile.token : '',
				paymentAmount: this.paymentAmount,
				'critical_care': this.critical_care,
				'first_name': this.first_name,
				'last_name': this.last_name,
				'mobile_phone_number': this.unmaskData(this.mobile_phone_number),
				'email': this.email,
				'date_of_birth': this.datePipe.transform(this.date_dob, 'yyyy-MM-dd'),
				'acc_pin': this.acc_pin,
				'create_password': this.create_password,
				'confirm_password': this.create_password,
				'prefered_lang': this.prefered_language,
				'service_type': this.service_type,
				'service_start_date': '' + this.date_service_start,
				'billing_address': this.billing_address.trim(),
				'billing_address_2': this.billing_address_2.trim(),
				'city': this.city.trim(),
				'state': this.state.trim(),
				'live_here': this.live_here,
				'notify_provider': this.notify_provider,
				'zip_code': this.zip_code,
				'service_address': this.billing_address_obj['address'],
				'service_address_2': '',
				'service_city': this.billing_address_obj['city'],
				'service_state': this.billing_address_obj['state'],
				'service_zip_code': this.billing_address_obj['zipcode'],
				'esi_id': this.billing_address_obj['esiId'],
				'IPAddress' : this.ip_Address,
				IsAutoPay: this.is_autopay_enable === true,
				SavePaymentProfile: this.isSavePaymentProfile,
				Cvv: this.cvv,
				StartWithCash: !this.enroll_with_payment
			}).then((res) => {
				const logObj = {
					method: this.constructor.name + '.paymentPay',
					request: {
						token: '[masked]',
						PaymentAmount: this.amountFormControl.value,
						PaymentMethodToken: this.enroll_with_payment ? this.primaryPaymentProfile.token : ''
					},
					response: res
				};
				this.logger.logInfo(JSON.stringify(logObj));
				console.log(res);
				this.paymentReceipt = {
					status: res.status,
					cardMessage: res.cardMessage,
					cardError: res.cardError,
					message: res.message,
					paymentConfirmationNumber: res.transactionID,
					accountBalance: res.accountBalance,
					paymentAmount: res.paymentAmount,
					paymentProfile: this.primaryPaymentProfile
				}
				this.isProcessingEnrollment = false;
				this.is_doing_payment = false;
			});
	}
}

export interface DialogData {
	title: string;
	message: string;
}


@Component({
	// tslint:disable-next-line:component-selector
	selector: 'info',
	// tslint:disable-next-line:max-line-length
	template: '<div class="dialog-main"><div class="dialog-info"><p>{{data.message}}</p></div></div><div class="footer"><button mat-button class="single-btn" [mat-dialog-close]="true">OK</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class InfoDialog {
	constructor(
		public dialogRef: MatDialogRef<CustomerEnrollWizardV2Component>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData) { }
}

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'mobile-phone-info',
	// tslint:disable-next-line:max-line-length
	template: '<div class="dialog-main"><div class="dialog-info"><h3 class="text-center">Why we need your mobile phone number</h3><p>You will use this number to sign into your account. We will use this number to send you important alerts about your balance and your account. We will not sell your phone number to 3rd parties. We hate SPAM as much as you do. (Text message and data rates may apply.)</p></div></div><div class="footer"><button mat-button class="single-btn" [mat-dialog-close]="true">OK</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class MobilePhoneInfo {

}


@Component({
	// tslint:disable-next-line:component-selector
	selector: 'date-of-birth-info',
	// tslint:disable-next-line:max-line-length
	template: '<div class="dialog-main"><div class="dialog-info"><h3 class="text-center">Why We Ask For Your Date of Birth</h3><p>You must be 18 years of age or older to enroll with Pogo Energy. Also, your two digit month and last two digits of your year of birth will be used as your default PIN to verify your identity should you ever need to talk to us.</p></div></div><div class="footer"><button mat-button class="single-btn" [mat-dialog-close]="true">OK</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class DateOfBirthInfo {

}

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'save-data-on-session-expire',
	// tslint:disable-next-line:max-line-length
	template: '<div class="dialog-main"><div class="dialog-info"><h3 class="text-center">Enrollment Session Expired</h3><p>Enrollment Process is taking too much time than usual. Do you want to save the current progress?</p></div></div><div class="footer"><button mat-button class="double-block-btn" (click)="yes()" style="width:50%;display: inline-block;border-bottom-left-radius: 7px;">Yes</button><button mat-button class="double-block-btn" (click)="no()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">No</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class SaveDataOnSessionExpire {
	constructor(public dialogRef: MatDialogRef<SaveDataOnSessionExpire>) {

	}

	yes() {
		this.dialogRef.close({ 'save': true });
	}

	no() {
		this.dialogRef.close({ 'save': false });
	}
}


export class PasswordValidation {
	static MatchPassword(AC: AbstractControl) {
		const password = AC.get('passwordFormControl').value; // to get value in input tag
		const confirmPassword = AC.get('confirmPasswordFormControl').value; // to get value in input tag
		if (password !== confirmPassword) {
			AC.get('confirmPasswordFormControl').setErrors({ MatchPassword: true })
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/customer-enroll/customer-enroll-wizard-v2/customer-enroll-wizard-v2.component.ts